import { render } from "./FileDownloadSettingsModal.vue?vue&type=template&id=20bea512&scoped=true"
import script from "./FileDownloadSettingsModal.vue?vue&type=script&lang=js"
export * from "./FileDownloadSettingsModal.vue?vue&type=script&lang=js"

import "./FileDownloadSettingsModal.vue?vue&type=style&index=0&id=20bea512&scoped=true&lang=less"
import "./FileDownloadSettingsModal.vue?vue&type=style&index=1&id=20bea512&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bea512"]])

export default __exports__